var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"content-wrapper"}},[_c('car-list'),_c('main-map')],1),_c('grafico-velocidad',{staticClass:"speedChart",attrs:{"id":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }